import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/PaginateClinicalSites';
import {
    useGetClinicalSitesQuery,
    useDeleteClinicalSiteMutation,
    useCreateClinicalSiteMutation,
} from '../../slices/clinicalSitesApiSlice';

import { toast } from 'react-toastify';

const ClinicalSiteListScreen = () => {
    const { pageNumber } = useParams();

    const { data, isLoading, error, refetch } = useGetClinicalSitesQuery({
        pageNumber,
    });

    const [deleteClinicalSite, { isLoading: loadingDelete }] =
        useDeleteClinicalSiteMutation();

    const deleteHandler = async (id) => {
        if (window.confirm(`Are you sure  ${id}`)) {
            try {
                await deleteClinicalSite(id);
                refetch();
            } catch (err) {
                toast.error(err?.data?.message || err.error);
            }
        }
    };

    const [createClinicalSite, { isLoading: loadingCreate }] =
        useCreateClinicalSiteMutation();

    const createClinicalSiteHandler = async () => {
        if (window.confirm('Are you sure you want to create a new Clinical Site?')) {
            try {
                await createClinicalSite();
                refetch();
            } catch (err) {
                toast.error(err?.data?.message || err.error);
            }
        }
    };

    return (
        <>
            <Row className='align-items-center'>
                <Col>
                    <h1>Clinical Sites</h1>
                </Col>
                <Col className='text-end'>
                    <Button className='my-3' onClick={createClinicalSiteHandler}>
                        <FaPlus /> Create A Clinical Site
                    </Button>
                </Col>
            </Row>

            {loadingCreate && <Loader />}
            {loadingDelete && <Loader />}
            {isLoading ? (
                <Loader />
            ) : error ? (
                <Message variant='danger'>{error.data.message}</Message>
            ) : (
                <>
                    <Table striped bordered hover responsive className='table-sm'>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Clinical Site Name</th>
                                <th> Description - Comments</th>
                                <th>Active Y or N</th>
                                <th>Paid Y or N</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.clinicalSites.map((clinicalSite) => (
                                <tr key={clinicalSite._id}>
                                    <td>{clinicalSite._id}</td>
                                    <td>{clinicalSite.clinicalSiteName}</td>
                                    <td>{clinicalSite.description}</td>
                                    <td>{clinicalSite.activeYorN}</td>
                                    <td>{clinicalSite.paidYorN}</td>

                                    <td>
                                        <LinkContainer to={`/admin/clinicalSite/${clinicalSite._id}/edit`}>
                                            <Button variant='outline-info' className='btn-sm mx-2'>
                                                <FaEdit /> Edit Item
                                            </Button>
                                        </LinkContainer>

                                        <Button
                                            variant='warning'
                                            className='btn-sm'
                                            onClick={() => deleteHandler(clinicalSite._id)}
                                        >
                                            <FaTrash className='text-end' style={{ color: 'white' }} /> Delete
                                        </Button>

                                    </td>

                                    {/*
                  

                                    <td>
                                        <LinkContainer to={`/admin/clinicalSite/${clinicalSite._id}/edit`}>
                                            <Button variant='light' className='btn-sm mx-2'>
                                                <FaEdit />
                                            </Button>
                                        </LinkContainer>
                                        <Button
                                            variant='danger'
                                            className='btn-sm'
                                            onClick={() => deleteHandler(clinicalSite._id)}
                                        >
                                            <FaTrash style={{ color: 'white' }} />
                                        </Button>
                                    </td>

                            */}

                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Paginate pages={data.pages} page={data.page} isAdmin={true} />
                </>
            )}
        </>
    );
};

export default ClinicalSiteListScreen;
